export default __webpack_public_path__ + "65bda104011fe6c9018462710b0c4c6e.png";